export default __webpack_public_path__ + "static/media/bg_repeat_340x640.df39cd6f.png";